import React from "react";
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@material-ui/core";
import { Table as TablePDF } from "@david.kucsai/react-pdf-table/lib/Table";
import { TableHeader as TableHeaderPDF } from "@david.kucsai/react-pdf-table/lib/TableHeader";
import { TableCell as TableCellPDF } from "@david.kucsai/react-pdf-table/lib/TableCell";
import { TableBody as TableBodyPDF } from "@david.kucsai/react-pdf-table/lib/TableBody";
import GetCurrency from "../../helper/GetCurrency";

export default function ViewVoids(props) {
  const getPdfView = () => {
    return (
      <TablePDF data={[0]}>
        <TableHeaderPDF>
          <TableCellPDF weighting={0.3}>Correcties</TableCellPDF>
          <TableCellPDF weighting={0.3} align={"right"}>
            Aantal
          </TableCellPDF>
          <TableCellPDF weighting={0.3} align={"right"}>
            Bedrag
          </TableCellPDF>
        </TableHeaderPDF>
        <TableBodyPDF>
          <TableCellPDF weighting={0.3} />
          <TableCellPDF weighting={0.3}>{props.voids.count}</TableCellPDF>
          <TableCellPDF weighting={0.3} align={"right"}>
            {GetCurrency() + (props.voids.amount / 100.0).toFixed(2)}
          </TableCellPDF>
        </TableBodyPDF>
      </TablePDF>
    );
  };

  props.createPdf(getPdfView());

  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Correcties</TableCell>
            <TableCell align={"right"}>Aantal</TableCell>
            <TableCell align={"right"}>Bedrag</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell />
            <TableCell align={"right"}>{props.voids.count}</TableCell>
            <TableCell align={"right"}>
              {GetCurrency()} {(props.voids.amount / 100.0).toFixed(2)}
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
}
